export const DEFAULT_RED_COLOR = "#e30613";
export const DEFAULT_WHITE_COLOR = "white";
export const DEFAULT_GOLD_COLOR = "#ceab5d";
export const TEAM_A_FONT_BOLD = "Team-A-Bold";
export const TEAM_A_FONT_REGULAR = "Team-A-Regular";

// BRANDED PSG
export const DEFAULT_PSG_EVENT_LOGO = "/psg/event_logo.png";
export const DEFAULT_PSG_TEAM_LOGO = "/psg/event_logo.png";
export const DEFAULT_PSG_BACKGROUND_MOBILE = "/psg/background_mobile.png";
export const DEFAULT_PSG_NAVIGATION_MENU_LOGO = "/parc-des-prince-logo.png";

// DEFAULT
// Play is use for mobile first usage
export const DEFAULT_PLAY_BACKGROUND = "/psg/bg.png";
export const DEFAULT_SCREEN_BACKGROUND = "/psg/bg.png";

// FOR TEST PURPOSE
// SCREEN = DESKTOP
// PLAY = MOBILE
export const DESKTOP_ORANGE_BACKGROUND = "/background_screen_orange_test.png";
export const MOBILE_PURPLE_BACKGROUND = "/background_mobile_purple_test.png";
export const GREEN_BACKGROUND = "/background_green_test.png";

export const CROSSBAR_DEFAULT_BACKGROUND =
  "/psg/crossbar/images/background.png";
export const DEFAULT_OPPONENT_LOGO = "/opponent.png";

// psg/crossbar/images/background

/* Images Url to search and replace by constants
/psg/background_desktop.png
*/
